import { formatMinutes } from "../../format-minutes.js";
import "react";
import { DataDisplay } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/ServicePeriods/activity-evals/occurrence/continuous/ContinuousOccurrenceDisplay.tsx
function ContinuousOccurrenceDisplay({ occurrence }) {
	return /* @__PURE__ */ jsxs(DataDisplay, {
		dividers: "space",
		space: "xs",
		children: [/* @__PURE__ */ jsx(DataDisplay.Item, {
			label: "Occurrence",
			children: "Continuous"
		}), /* @__PURE__ */ jsx(DataDisplay.Item, {
			label: "Maximum gap",
			children: formatMinutes(occurrence.maxGapMinutes)
		})]
	});
}
//#endregion
export { ContinuousOccurrenceDisplay };

//# sourceMappingURL=ContinuousOccurrenceDisplay.js.map